export default __webpack_public_path__ + "static/media/SamsungOne-700_v1.0.7a5ca177.ttf";